<template>
  <div class="invoice-pop" v-show="invoiceActive">
    <div class="pop-fp">
      <a class="close-btn" @click="invoiceActive = false">x</a>
      <div class="pop-fp-item">
        <h5>
          发票类型
          <a class="cur">电子普通发票</a>
        </h5>
      </div>
      <div class="pop-fp-item">
        <h5 class="invoiceTitleType">
          发票抬头
          <a @click="getUserInfo(1)" :class="{'cur': invoiceTitleType == 1 }">默认个人</a>
          <a @click="getUserInfo(2)" :class="{'cur': invoiceTitleType == 2 }">默认单位</a>
        </h5>
        <div class="ipt-w" v-show="invoiceTitleType == 2">
          <input class="fl" type="text" v-model="buyerName" placeholder="请填写单位名称" />
          <input
            class="fl"
            type="text"
            v-model="buyerTaxpayerIdNo"
            placeholder="请填写统一社会信用代码"
            onkeydown="if(event.keyCode==32) return false"
          />
        </div>
      </div>
      <div class="pop-fp-item">
        <h5>收票人信息</h5>
        <div>
          <span class="ipt-tit fl">*收票人手机</span>
          <input
            type="text"
            v-model="receiveMobile"
            class="invoice-ipt fl"
            placeholder="可通过手机号在发票服务平台查询"
          />
        </div>
        <div>
          <span class="ipt-tit fl">收票人邮箱</span>
          <input type="text" v-model="receiveMail" class="invoice-ipt fl" placeholder="用来接收电子发票邮件" />
        </div>
      </div>
      <div class="pop-fp-item">
        <h5>
          发票内容
          <span>发票内容选项已根据税法调整，具体请以展示为准</span>
        </h5>
        <div>
          <span class="ipt-tit fl">商品类别</span>
          <p class="fl">信息技术服务</p>
        </div>
      </div>
      <a class="pop-fp-btn" @click="saveUserInfo">确认</a>
      <dl class="pop-fp-rules">
        <dt>发票须知</dt>
        <dd>
          <p>1.发票金额为实付金额，将于订单完成后24小时内开具。</p>
         <p> 2.购买方为企业的，索取增值税普通发票时，应填写纳税人识别号或统一社会信用代码;长度为18位。为确保发票开具的准确性，建议与公司财务确认后填写。</p>
          <p>3.电子普通发票：<br>
          （1）电子普通发票是税局认可的有效收付款凭证，其法律效力、基本用途及使用规定同纸质发票，如需纸质发票可自行下载打印；<br>
          （2）用户可进入大智慧官网订单中心查询和下载电子发票</p>
          <p>4.如有疑问可咨询大智慧客服 021-20219997.发票金额为实付金额，将于订单完成后24小时内开具。</p>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      invoiceActive: false,
      invoiceTitleType: 1,
      buyerName: "",
      buyerTaxpayerIdNo: "",
      receiveMobile: "",
      receiveMail: "",
      usersaveable: true
    };
  },
  created() {
    this.getInvoiceTitle();
  },
  methods: {
    openInvoice() {
      this.invoiceActive = true;
      this.getUserInfo(this.invoiceTitleType);
    },
    saveUserInfo() {
      // 保存用户发票信息
      if (!this.usersaveable) {
        return false;
      }
      if (this.invoiceTitleType == 2) {
        if (!this.buyerName) {
          this.$global.alert("请填写单位名称");
          return false;
        }
        if (this.buyerName.length <= 0 || this.buyerName.length > 100) {
          this.$global.alert("单位名称长度在1-100之间");
          return false;
        }
        if (!this.buyerTaxpayerIdNo) {
          this.$global.alert("请填写纳税人识别号");
          return false;
        }
        if (
          this.buyerTaxpayerIdNo.length < 15 ||
          this.buyerTaxpayerIdNo.length > 20
        ) {
          this.$global.alert("纳税人识别号不规范，请准确填写");
          return false;
        }
      }
      if (!this.receiveMobile) {
        this.$global.alert("请输入收票人手机号码");
        return false;
      }
      if (!this.$validate.checkPhone(this.receiveMobile)) {
        this.$global.alert("请输入正确的收票人手机号码");
        return false;
      }
      if (this.receiveMail) {
        if (!this.$validate.checkMail(this.receiveMail)) {
          this.$global.alert("请输入正确的收票人邮箱");
          return false;
        }
      }
      var params = {
        invoiceTitleType: this.invoiceTitleType,
        receiveMobile: this.receiveMobile
      };
      if (this.receiveMail) {
        params.receiveMail = this.receiveMail;
      }
      if (this.buyerName) {
        params.buyerName = this.buyerName;
      }
      if (this.buyerTaxpayerIdNo) {
        params.buyerTaxpayerIdNo = this.buyerTaxpayerIdNo;
      }
      this.usersaveable = false;
      this.$post("/invoice/usersave", params)
        .then(response => {
          if (response.code === 0) {
            this.$global.alert("默认发票信息已更新，后续商城订单将以您最新更新的信息开具发票");
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
          this.usersaveable = true;
        })
        .catch(err => {
          this.usersaveable = true;
          this.$global.alertError();
        });
    },
    getUserInfo(invoiceTitleType) {
      this.invoiceTitleType = invoiceTitleType;
      this.$emit("changeInvoiceTitleType", this.invoiceTitleType);
      this.$emit("saveInvoiceTitleType", this.invoiceTitleType);
      // 查询用户发票信息
      this.$get("/invoice/userget?invoiceTitleType=" + this.invoiceTitleType)
        .then(response => {
          if (response.code === 0) {
            if (response.data) {
              this.buyerName = response.data.buyerName;
              this.buyerTaxpayerIdNo = response.data.buyerTaxpayerIdNo;
              this.receiveMobile = response.data.receiveMobile;
              this.receiveMail = response.data.receiveMail;
            }else{
              this.buyerName = "";
              this.buyerTaxpayerIdNo = "";
              this.receiveMobile = "";
              this.receiveMail = "";
            }
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
    getInvoiceTitle() {
      this.$get("/invoice/userInvoiceTitle")
        .then(response => {
          if (response.code === 0) {
            var val = 1
            if (response.data) {
              val = response.data
            }
            this.invoiceTitleType = val;
            this.$emit("changeInvoiceTitleType", val);
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertError();
        });
    },
  }
};
</script>

<style scope>
.invoice-pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 5;
}
.invoice-pop .pop-fp {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 556px;
  background: #fff;
  border: 1px solid #9eaacb;
  box-shadow: 0 3px 4px #909090;
  margin: -278px 0 0 -299px;
  padding: 17px 20px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  border-radius: 5px;
}
.fl {
  float: left;
}
.invoice-pop .close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 24px;
  height: 24px;
  background: #ecf3ff;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  color: #166fff;
  text-align: center;
  /* line-height: 22px; */
  font-size: 20px;
  text-decoration: none;
}
.invoice-pop .pop-fp-item h5 {
  font-size: 18px;
  /* line-height: 26px; */
  height: 26px;
  margin-bottom: 15px;
}
.invoice-pop .pop-fp-item h5 span {
  font-size: 16px;
  color: #818181;
  margin-left: 20px;
}
.invoice-pop .pop-fp-item h5 a {
  display: inline-block;
  margin-left: 20px;
  padding: 0 18px;
  background: #fff;
  font-size: 16px;
  /* line-height: 22px; */
  color: #323232;
  height: 24px;
  border: 1px solid #efefef;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  font-weight: normal;
  vertical-align: top;
}
.invoice-pop .pop-fp-item h5 a.cur {
  background: #ecf3ff;
  border-color: #166fff;
  color: #166fff;
}
.invoice-pop .pop-fp-item {
  margin-bottom: 22px;
}
.invoice-pop .pop-fp-item div {
  height: 18px;
  line-height: 18px;
  font-size: 16px;
  margin-bottom: 15px;
}
.invoice-pop .pop-fp-item div.ipt-w input {
  width: 255px;
}
.invoice-pop .pop-fp-item div input {
  padding: 0 10px;
  height: 18px;
  border: 0;
  border-left: 1px solid #3179ff;
  width: 400px;
}
.invoice-pop .ipt-tit {
  width: 92px;
  text-align: right;
  margin-right: 15px;
}
.invoice-pop .pop-fp-btn {
  display: block;
  width: 100%;
  font-size: 18px;
  color: #fff;
  text-align: center;
  background: #166fff;
  line-height: 40px;
  height: 40px;
  text-decoration: none;
}
.invoice-pop .pop-fp-rules {
  font-size: 16px;
  margin-top: 10px;
}
.invoice-pop .pop-fp-rules dt {
  line-height: 30px;
}
.invoice-pop .pop-fp-rules dd {
  background: #f2f2f2;
  overflow: hidden;
  overflow-y: auto;
  height: 94px;
  padding: 10px;
}
.invoice-pop .pop-fp-rules dd p {
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/Invoice.vue